import * as detail from "../page/detail.js";
import { Top } from "../class/Top.js";
import * as doplnkoveSluzby from "./doplnkove-sluzby.js";


export function doplnek_vymena_ram() {
  var $data = detail.paramDetail("opt_ram");

  var $objekt = get(window.sortimentDoplnky, "RAM") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.RAM, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    popis: $objekt.name,
    linkText:$objekt.linkText,
    url:$objekt.url,
    items:$items,
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_vymena_ram",
      $items,
      $objekt.name
    ),
    radioButtony:doplnkoveSluzby.dopln_vytvor_radio_buttony(
      "upgrade_zvyseni_ram",
      $items,
      $objekt.name
    ),
  };
} //function  doplnek_vymena_ram()

export function doplnek_vymena_disku() {
  var $data = detail.paramDetail("opt_disky");

  var $objekt = get(window.sortimentDoplnky, "DISKY") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.DISKY, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    popis: $objekt.name,
    linkText:$objekt.linkText,
    url:$objekt.url,
    items:$items,
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_vymena_disku",
      $items,
      $objekt.name
    ),
    radioButtony:doplnkoveSluzby.dopln_vytvor_radio_buttony(
      "upgrade_vymena>_disku",
      $items,
      $objekt.name
    ),
  };
} //function  doplnek_vymena_disku()

export function doplnek_pridani_disku() {
  var $data = detail.paramDetail("opt_pridat_disk");

  var $objekt = get(window.sortimentDoplnky, "PRIDAT_DISK") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.PRIDAT_DISK, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "grafika",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_pridani_disku",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_disku()


export function doplnek_pridani_rgbkit() {
  var $data = detail.paramDetail("opt_rgbkit");

  var $objekt = get(window.sortimentDoplnky, "RGBKIT") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.RGBKIT, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "rgbkit",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_rgbikt",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_rgbkit()


export function doplnek_pridani_chlazeni() {
  var $data = detail.paramDetail("opt_chlazeni");

  var $objekt = get(window.sortimentDoplnky, "CHLAZENI") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.CHLAZENI, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "chlazeni",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_chlazeni",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_chlazeni()

export function doplnek_pridani_zaruky() {
  var $data = detail.paramDetail("opt_zaruka");

  var $objekt = get(window.sortimentDoplnky, "ZARUKA") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.ZARUKA, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "zaruka",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_zaruka",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_zaruky()

export function doplnek_pridani_baterie() {
  var $data = detail.paramDetail("opt_bat");

  var $objekt = get(window.sortimentDoplnky, "BAT") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.BAT, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "baterie",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_baterie",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_baterie()


export function doplnek_pridani_grafiky() {
  Lc.f('doplnek_pridani_grafiky');
  var $data = detail.paramDetail("opt_pridat_grafiku");

  var $objekt = get(window.sortimentDoplnky, "PRIDAT_GRAFIKU") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.PRIDAT_GRAFIKU, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "pridani_grafiky",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_pridani_grafiku",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_pridani_grafiky()

export function doplnek_zmena_grafiky() {
  Lc.f('doplnek_zmena_grafiky');
  var $data = detail.paramDetail("opt_zmenit_grafiku");

  var $objekt = get(window.sortimentDoplnky, "ZMENIT_GRAFIKU") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.ZMENIT_GRAFIKU, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      pricenoVAT: Top.prevedNaEura($o.pricenoVAT),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    name:$objekt.name,
    obr:$objekt.obr,
    popis: $objekt.name,
    url:$objekt.url,
    idPrvku: "zmena_grafiky",
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_zmenit_grafiku",
      $items,
      $objekt.prvniVolba
    )
  };
} //function  doplnek_zmena_grafiky()


export function doplnek_predinstalace_programu() {
  var $stav = detail.paramDetail("opt_predinstalace");

  var $objekt = get(window.sortimentDoplnky, "PREDINSTALACE") || false;

  if (!$stav || !$objekt) return false;

  $objekt.price= Top.prevedNaEura($objekt.price);
  $objekt.pricenoVAT= Top.prevedNaEura($objekt.pricenoVAT);


  return {
    name:$objekt.name,
    idPrvku:'predinstalace',
    url:$objekt.url,
    linkText:$objekt.linkText,
    popis:
      '<label><input type="checkbox" class="doplnekUprade" id="doplnek_predinstalace" value="' +
      $objekt.priceID +
      '">' +
      $objekt.name +
      " + " +
      $objekt.price.formatCisla() +
      ' Kč </label> &rarr;  <a href="' +
      $objekt.url +
      '" rel="modal:open">' +
      $objekt.linkText +
      "</a>",
    cena: $objekt.price,
    anoNe: doplnkoveSluzby.dopln_vytvor_anoNe(
      "predinstalace",
      $objekt
    )
  };
} //function  doplnek_predinstalace_programu()

export function doplnek_okamzita_vymena() {
  var $stav = detail.paramDetail("opt_vymena");

  var $objekt = get(window.sortimentDoplnky, "OKAMZITA_VYMENA") || false;

  if (!$stav || !$objekt) return false;

  return {
    popis:
      '<label><input type="checkbox" class="doplnekUprade" id="doplnek_okamzita_vymena" value="' +
      $objekt.priceID +
      '">' +
      $objekt.name +
      " + " +
      $objekt.price.formatCisla() +
      ' Kč </label> &rarr;  <a href="' +
      $objekt.url +
      '" rel="modal:open">' +
      $objekt.linkText +
      "</a>",
    cena: $objekt.price
  };
} //function  doplnek_okamzita_vymena()

export function doplnek_preinstalace_os() {
  var $objekt = get(window.sortimentDoplnky, "PREINSTALACE_OS") || false;

  if (!$objekt) return false;

  return {
    popis:
      '<label><input type="checkbox" class="doplnekUprade" id="doplnek_predinstalace_os" value="' +
      $objekt.priceID +
      '">' +
      $objekt.name +
      " + " +
      $objekt.price.formatCisla() +
      ' Kč </label> &rarr;  <a href="' +
      $objekt.url +
      '" rel="modal:open">' +
      $objekt.linkText +
      "</a>",
    cena: $objekt.price
  };
} //function  doplnek_preinstalace_os()

export function doplnek_upgrade_windows() {
  var $data = detail.paramDetail("opt_upgrade_windows");

  var $objekt = get(window.sortimentDoplnky, "UPGRADE_WINDOWS") || false;

  if (!$data.length || !$objekt) return false;

  var $items = [];
  $data.forEach(function(entry) {
    var $o = get(window.sortimentDoplnky.UPGRADE_WINDOWS, entry) || false;
    if (!$o) return;

    $items.push({
      name: $o.name,
      price: Top.prevedNaEura($o.price),
      priceID: $o.priceID
    });
  });

  if (!$items.length) return false;

  return {
    popis: $objekt.name,
    select: doplnkoveSluzby.dopln_vytvor_select(
      "upgrade_windows",
      $items,
      $objekt.name
    )
  };
} //function  doplnek_upgrade_windows()
